/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Edit_Contract_Seats_FloorInputs */



/**
* | output |
* | --- |
* | "At least {count} — that is how many members use a paid seat now (guests don't count)." |
*
* @param {Partner_Edit_Contract_Seats_FloorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_seats_floor = /** @type {((inputs: Partner_Edit_Contract_Seats_FloorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_Seats_FloorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mindestens ${i?.count} — so viele Mitglieder belegen derzeit einen bezahlten Platz (Gäste zählen nicht).`)
	return /** @type {LocalizedString} */ (`At least ${i?.count} — that is how many members use a paid seat now (guests don't count).`)
});